import React from "react";
import { Button } from "@mui/material";
import { useLocation } from "react-router-dom";


export const StButton = (props) => {
    const location = useLocation();
    const currentPath = location.pathname;

    
    // Normalize paths by removing trailing slashes
    const normalizePath = (path) => path.replace(/\/+$/, ""); // Removes one or more trailing slashes
    const normalizedCurrentPath = normalizePath(currentPath);
    const normalizedHit = normalizePath(props.hit);
  
    const isActive = normalizedCurrentPath === normalizedHit;
  
    return (

        <Button
        variant="outlined"

        href={props.hit || "#"}
        sx={{
          mx: 1,
          borderRadius: 20,
          height: 30,
          fontSize: "15px",
          fontFamily: "Comfortaa",
          borderColor: "#fecc00",
          color:"black",
          bgcolor: props.isActive ? "#fecc00" : "",
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: "#fecc00",
            color: "white",
            borderColor:"white",
          },
        }}
      >
        {props.text}
      </Button>
      
    );
  };